import { Validators } from '@angular/forms';

export declare type ControlProperty<Type> =
  | Type
  | [{ value: Type; disabled: boolean }, Validators | Validators[]]
  | [Type, Validators | Validators[]];

// todo: remove specified types after changing them to ControlProperty<Type>
export declare type ControlStringProperty = ControlProperty<string>;
export declare type ControlBooleanProperty = ControlProperty<boolean>;
export declare type ControlNumberProperty = ControlProperty<number>;
